import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import SectionList from "./section-list";
import { NUMBER } from "../../../constants/app-constants";
// import FeatureNoResultFound from "../../shared/feature-no-result-found";
import SearchNoResult from "./images/search-no-result.webp";
import LazyImage from "../../shared/lazy-image";
const SearchSuggestions = ({ suggestions = [], searchText = "", baseUrl = "" }) => {
    const renderNoResultsFound = () => {
        if (searchText && searchText.length >= NUMBER.TWO) {
            return (<div styleName={"styles.noResultsFound"}>
                <LazyImage src={SearchNoResult} width= {217} height= {217} />
                <p>Sorry, No results found</p>
            </div>);
        }
        return <Fragment />;
    };

    const renderSearchSuggestions = () => {
        if (suggestions && suggestions.length) {
            return (<ul styleName={"styles.inspectionReportDetail"}>
                <React.Fragment>
                    {suggestions.map((section, index) => {
                        return (
                            <React.Fragment key={index}>
                                {<React.Fragment>
                                    <h5 styleName={"styles.searchHeading"}>{section.label}</h5>
                                    <SectionList
                                        activeTabKey={section.key}
                                        detailReport={section}
                                        baseUrl={baseUrl}
                                        showingSearchSuggestions={true}
                                    />
                                </React.Fragment>}
                            </React.Fragment>
                        );
                    })}
                </React.Fragment>
            </ul>);
        }
        return renderNoResultsFound();
    };

    return (
        <React.Fragment>
            {renderSearchSuggestions()}
        </React.Fragment>
    );
};

SearchSuggestions.propTypes = {
    suggestions: PropTypes.array,
    searchText: PropTypes.string,
    baseUrl: PropTypes.string
};
export default SearchSuggestions;
